import {Pipe, PipeTransform} from "@angular/core";
import {SimRecordingsService} from "@services";
import {ScenarioRecording} from "@models";
import {from, Observable} from "rxjs";

@Pipe({
	name: "getScenarioRecordingById",
	standalone: false,
})
export class GetScenarioRecordingByIdPipe implements PipeTransform {
	constructor(private _simRecordingsService: SimRecordingsService) {}

	transform(scenarioRecordingId: string): Observable<ScenarioRecording> {
		return from(this._simRecordingsService.getRecordingById(scenarioRecordingId));
	}
}
